{
  "generic": {
    "no": "No",
    "yes": "Sì",
    "text": "Testo "
  },
  "consent": {
    "defaultLabelText": "Inviando questo modulo accetti la nostra ",
    "defaultLabelLink": "informativa sulla privacy"
  },
  "text": {
    "defaultHeadlineText": "Questo è un titolo",
    "defaultText": "Questo è un blocco di testo",
    "floatingDefaultText": "NUOVO!"
  },
  "button": {
    "submitDefaultText": "Invia",
    "instagramDefaultText": "Seguici",
    "defaultText": "Clicca qui",
    "closing": "CHIUSURA..."
  },
  "input": {
    "emailLabel": "Email",
    "emailPlaceholder": "Inserisci la tua email",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Inserisci password",
    "nameLabel": "Nome",
    "namePlaceholder": "Inserisci il tuo nome",
    "firstNameLabel": "Nome",
    "firstNamePlaceholder": "Inserisci nome",
    "lastNameLabel": "Cognome",
    "lastNamePlaceholder": "Inserisci cognome",
    "phoneLabel": "Telefono",
    "phonePlaceholder": "Inserisci numero di telefono",
    "textareaLabel": "Messaggio",
    "textareaPlaceholder": "Inserisci il tuo messaggio",
    "regularLabel": "Testo",
    "regularPlaceholder": "Inserisci testo",
    "defaultLabel": "Etichetta",
    "defaultPlaceholder": "Segnaposto",
    "datePlaceholder": "Seleziona data",
    "stepLabel": "Inserisci la tua domanda qui"
  },
  "dropdown": {
    "placeholder": "Seleziona un'opzione",
    "firstItem": "Opzione 1",
    "secondItem": "Opzione 2",
    "chooseCountry": "Paese"
  },
  "buttonList": {
    "firstItem": "Opzione 1",
    "secondItem": "Opzione 2",
    "option1": "Scelta 1",
    "option2": "Scelta 2",
    "option3": "Scelta 3",
    "subscriptionItem1": "Newsletter",
    "subscriptionItem2": "Aggiornamenti",
    "chooseSubscriptionTopics": "Scegli argomenti di abbonamento",
    "other": "Altro",
    "uncheck-all-label": "Non desidero ricevere nessuna di queste email"
  },
  "rating": {
    "rateLabel": "Valutaci",
    "npsLabel": "Quanto è probabile che ci consiglierai?",
    "veryUnsatisfied": "Molto insoddisfatto",
    "unsatisfied": "Insoddisfatto",
    "neutral": "Neutrale",
    "satisfied": "Soddisfatto",
    "loveIt": "Lo adoro!",
    "minValueLabel": "Basso",
    "maxValueLabel": "Alto",
    "minValueLabelNps": "Poco probabile",
    "maxValueLabelNps": "Molto probabile"
  },
  "deadline": {
    "days": "Giorni",
    "hours": "Ore",
    "minutes": "Minuti",
    "seconds": "Secondi"
  },
  "bulletList": {
    "firstItem": "Vantaggio 1",
    "secondItem": "Vantaggio 2"
  },
  "discountCode": {
    "copyMessage": "Copiato negli appunti!",
    "fallback": "WELCOME10",
    "textDefault": "Il tuo codice sconto",
    "buttonDefault": "Copia"
  },
  "share": {
    "buttonText": "Condividi"
  },
  "common": {
    "label": "Etichetta"
  },
  "wcag": {
    "banner": "Banner promozionale",
    "closeButton": "Chiudi",
    "submitButton": "Invia modulo"
  },
  "spinTheWheel": {
    "prizeWonText": "Congratulazioni!",
    "prizeWonButtonText": "Riscuoti il tuo premio",
    "prizeLostText": "Ahhh, peccato! :-(",
    "prizeLostButtonText": "Clicca per chiudere",
    "spinButtonLabel": "GIRA"
  },
  "memory": {
    "resultWonText": "Ottimo lavoro! Il tuo tempo è stato {elapsedTime}",
    "resultWonButtonText": "Riscuoti il tuo premio"
  },
  "stepNavigation": {
    "nextButtonText": "Avanti",
    "previousButtonText": "Indietro",
    "lastButtonText": "Chiudi",
    "submitButtonText": "Invia"
  },
  "defaultRealTimeMessage": {
    "validationError": "Si prega di rivedere il formato dei dati inviati.",
    "unknownError": "Si è verificato un problema imprevisto durante l'invio.",
    "conflictError": "Questo utente esiste già.",
    "success": "Modulo inviato."
  }
}
